import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserService } from '@services/admin/user.service';
import { Observable } from 'rxjs';
import { LoggerService } from '@services/logger.service';
import { environment } from '../../../../environments/environment';
import { ROUTE_ROLES } from '@/config/role-config';

const BASE_CLASSES = 'main-sidebar elevation-4';

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss'],
  providers: [UserService],
})
export class MenuSidebarComponent implements OnInit {
  @HostBinding('class') classes: string = BASE_CLASSES;
  public ui: Observable<UiState>;
  public user;
  public menu = [];
  environment: string = environment.env;

  constructor(
    public appService: UserService,
    private store: Store<AppState>,
    private logger: LoggerService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.ui = this.store.select('ui');
    // Guard against undefined state which can happen in unit tests when the Store
    // is provided via `provideMockStore` without an initial `ui` slice.
    this.ui.subscribe((state: UiState | undefined) => {
      if (state && state.sidebarSkin) {
        this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
      }
    });
    this.user = this.appService.user;

    this.filterMenuByRoles();
  }

  protected getMenu(): Array<any> {
    return [
      {
        name: 'Home',
        iconClasses: 'fas fa-home',
        path: ['/'],
      },
      {
        name: 'Cassa',
        iconClasses: 'fas fa-archive',
        roles: ROUTE_ROLES.CASH_MANAGEMENT.roles,
        children: [
          {
            name: 'Movimenti cassa',
            iconClasses: 'fas fa-euro-sign',
            path: ['/cash-management/cash-movements'],
            roles: ROUTE_ROLES.CASH_MANAGEMENT.roles,
          },
          {
            name: 'Quadrature cassa',
            iconClasses: 'fas fa-table',
            path: ['/cash-management/cash-movements-analisis'],
            roles: ROUTE_ROLES.CASH_MOVEMENTS_ANALYSIS.roles,
          },
        ],
      },
      {
        name: 'Pratiche',
        iconClasses: 'fas fa-archive',
        roles: ROUTE_ROLES.PRACTICES.roles,
        children: [
          {
            name: 'Gestione pratiche',
            iconClasses: 'fas fa-calendar',
            path: ['/practices-management/practices'],
            roles: ROUTE_ROLES.PRACTICES.roles,
          },
          {
            name: 'Vetture aziendali Paolo Crespi',
            iconClasses: 'fas fa-calendar',
            path: ['/practices-management/business-machines'],
            roles: ROUTE_ROLES.BUSINESS_MACHINES.roles,
          },
          {
            name: 'Numeratori consegne',
            iconClasses: 'fas fa-calendar',
            path: ['/practices-management/delivery-cardboard'],
            roles: ROUTE_ROLES.DELIVERY_CARDBOARD.roles,
          },
          {
            name: 'Obiettivi marca',
            iconClasses: 'fas fa-calendar',
            path: ['/practices-management/brand-goals'],
            roles: ROUTE_ROLES.BRAND_GOALS.roles,
          },
        ],
      },
      {
        name: 'Gestione V.A. & Noleggi',
        iconClasses: 'fas fa-car',
        roles: ROUTE_ROLES.RENTAL_PRACTICES.roles,
        children: [
          {
            name: 'Lista Veicoli',
            iconClasses: 'fas fa-list',
            path: ['/rental-practices/list'],
            roles: ROUTE_ROLES.RENTAL_PRACTICES.roles,
          },
          {
            name: 'Timeline Noleggi',
            iconClasses: 'fas fa-calendar-alt',
            path: ['/rental-practices/timeline'],
            roles: ROUTE_ROLES.RENTAL_PRACTICES.roles,
          },
          {
            name: 'Prenotazioni Noleggio',
            iconClasses: 'fas fa-calendar-check',
            path: ['/rental-practices/reservations'],
            roles: ROUTE_ROLES.RENTAL_PRACTICES.roles,
          },
        ],
      },
      {
        name: 'Gestione CEM',
        iconClasses: 'fas fa-tools',
        path: ['/garage-passages'],
        roles: ROUTE_ROLES.GESTIONE_CEM.roles,
      },
      {
        name: 'Gestione assicurazioni',
        iconClasses: 'fas fa-car',
        path: ['/insurances'],
        roles: ROUTE_ROLES.INSURANCES.roles,
      },
      {
        name: 'Test Drive',
        iconClasses: 'fas fa-car-side',
        path: ['/test-drive'],
        roles: ROUTE_ROLES.TEST_DRIVE.roles,
      },
      {
        name: 'Tabella anagrafica telai',
        iconClasses: 'fas fa-car-side',
        path: ['/vehicle-registry'],
        roles: ROUTE_ROLES.VEHICLE_REGISTRY.roles,
      },
      {
        name: 'Anagrafica clienti',
        iconClasses: 'fas fa-table',
        path: ['/customers'],
        roles: ROUTE_ROLES.CUSTOMERS.roles,
      },
      {
        name: 'Gestione MMSS',
        iconClasses: 'fas fa-archive',
        roles: ROUTE_ROLES.MMSS.roles,
        children: [
          {
            name: 'Simulatore MS',
            iconClasses: 'fas fa-percent',
            path: ['/mmss-management/simulator-ms'],
            roles: ROUTE_ROLES.MMSS.roles,
          },
          {
            name: 'Tabella MS',
            iconClasses: 'fas fa-table',
            path: ['/mmss-management/table-ms'],
            roles: ROUTE_ROLES.MMSS.roles,
          },
          {
            name: 'Documentazione MMSS',
            iconClasses: 'fas fa-file-alt',
            path: ['/mmss-management/documentation-mmss'],
            roles: ROUTE_ROLES.MMSS.roles,
          },
        ],
      },
      {
        name: 'Gestione usato',
        iconClasses: 'fas fa-cart-plus',
        path: ['/used-vehicle-management'],
        roles: ROUTE_ROLES.USED_VEHICLE.roles,
      },
      {
        name: 'Gestione stock',
        iconClasses: 'fas fa-cart-plus',
        path: ['/stock-management'],
        roles: ROUTE_ROLES.STOCK.roles,
      },
      {
        name: 'Importazioni',
        iconClasses: 'fas fa-table',
        roles: ROUTE_ROLES.IMPORTS.roles,
        children: [
          {
            name: 'Riepilogo Importazioni',
            iconClasses: 'fas fa-chart-bar',
            path: ['/imports/summary'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'Cross F7',
            iconClasses: 'fas fa-table',
            path: ['/imports/crossf7'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'Cross F7 Cancellate',
            iconClasses: 'fas fa-list',
            path: ['/imports/practice-deleted'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'Cross F8',
            iconClasses: 'fas fa-table',
            path: ['/imports/crossf8'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'Loyalty',
            iconClasses: 'fas fa-table',
            path: ['/imports/loyalty'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'FT Provvigioni VW Bank',
            iconClasses: 'fas fa-table',
            path: ['/imports/vwbankCommission'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'VWFS Cruscotti',
            iconClasses: 'fas fa-table',
            path: ['/imports/vwfsDashboard'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'VWFS Provvigioni',
            iconClasses: 'fas fa-table',
            path: ['/imports/vwfsCommission'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'VWFS Telai',
            iconClasses: 'fas fa-table',
            path: ['/imports/vwfsFrame'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'VHM ProForma',
            iconClasses: 'fas fa-table',
            path: ['/imports/vhmProForma'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'VHM Report',
            iconClasses: 'fas fa-table',
            path: ['/imports/vhmReport'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
          {
            name: 'Ordini SLI',
            iconClasses: 'fas fa-table',
            path: ['/imports/orderSli'],
            roles: ROUTE_ROLES.IMPORTS.roles,
          },
        ],
      },
      {
        name: 'Tabelle',
        iconClasses: 'fas fa-table',
        roles: ROUTE_ROLES.TABLES.roles,
        children: [
          {
            name: 'Marche',
            iconClasses: 'fas fa-table',
            path: ['/tables/brand'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Noleggio pratiche',
            iconClasses: 'fas fa-table',
            path: ['/tables/rental-practices'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Azioni pratiche',
            iconClasses: 'fas fa-table',
            path: ['/tables/action-practices'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Servizi pratiche',
            iconClasses: 'fas fa-table',
            path: ['/tables/service-practices'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Tipo servizi assicurativi',
            iconClasses: 'fas fa-table',
            path: ['/tables/insurance-service-type'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Agenzie subagenti',
            iconClasses: 'fas fa-table',
            path: ['/tables/subagent-agency'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Gestione venditori',
            iconClasses: 'fas fa-table',
            path: ['/tables/seller'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Provvigione venditori',
            iconClasses: 'fas fa-table',
            path: ['tables/commissions'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Provvigione segnalatori',
            iconClasses: 'fas fa-table',
            path: ['tables/commissions-signalman'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Grandi acquirenti',
            iconClasses: 'fas fa-table',
            path: ['/tables/big-buyers'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Agenzie noleggio',
            iconClasses: 'fas fa-table',
            path: ['/tables/rental-agency'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Accessori veicoli',
            iconClasses: 'fas fa-table',
            path: ['/tables/vehicle-accessory'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Modelli',
            iconClasses: 'fas fa-table',
            path: ['/tables/models'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Tipo pagamento',
            iconClasses: 'fas fa-table',
            path: ['/tables/payment-type'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Origine contatto',
            iconClasses: 'fas fa-table',
            path: ['/tables/contact-source'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Garanzia',
            iconClasses: 'fas fa-table',
            path: ['/tables/warranty'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Banche',
            iconClasses: 'fas fa-table',
            path: ['/tables/bank-account'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
          {
            name: 'Gestione menu BI',
            iconClasses: 'fas fa-table',
            path: ['/tables/menu-bi-config'],
            roles: ROUTE_ROLES.TABLES.roles,
          },
        ],
      },
      {
        name: 'Amministrazione',
        iconClasses: 'fas fa-cogs',
        roles: ROUTE_ROLES.ADMIN.roles.concat(ROUTE_ROLES.GESTORE_UTENTI.roles),
        children: [
          {
            name: 'Utenti',
            iconClasses: 'far fa-user',
            path: ['/admin/users'],
            roles: ROUTE_ROLES.GESTORE_UTENTI.roles,
          },
          {
            name: 'Aziende',
            iconClasses: 'far fa-building',
            path: ['/admin/company'],
            roles: ROUTE_ROLES.ADMIN.roles,
          },
        ],
      },
      {
        name: 'Menu BI',
        iconClasses: 'fas fa-cart-plus',
        path: ['/menu-bi'],
        roles: ROUTE_ROLES.MENU_BI.roles,
      },
    ];
  }

  private filterMenuByRoles() {
    const menuAuthorized = [];
    const rolesUser = this.userService.getUserRoles();

    this.getMenu().forEach(function (mainVoice) {
      let childrenMenus = mainVoice.children ?? [];
      let childrenMenuAuthorized = [];
      mainVoice.children = [];
      let mainIsAuthorized = true;

      if (mainVoice.roles) {
        mainIsAuthorized = mainVoice.roles.some((element) => {
          return rolesUser.includes(element);
        });
      }

      childrenMenus.forEach(function (childrenMenu) {
        let childrenIsAuthorized = true;

        if (childrenMenu['roles']) {
          LoggerService.log(childrenMenu['roles']);
          childrenIsAuthorized = childrenMenu['roles'].some((element) => {
            return rolesUser.includes(element);
          });
        }

        if (childrenIsAuthorized) {
          childrenMenuAuthorized.push(childrenMenu);
        }
      });

      if (mainIsAuthorized) {
        mainVoice.children = childrenMenuAuthorized;
        menuAuthorized.push(mainVoice);
      }
    });

    this.menu = menuAuthorized;
  }
}
